const Card = ({
  style, children, className, id, borderRadius = 'rounded-lg', bgColor = 'bg-content2', tabIndex, onKeyDown, ...props
}) => (
  <div {...props} id={id} tabIndex={tabIndex} onKeyDown={onKeyDown} style={style} key={props?.key} className={`border-focused border-grey-200 dark:border-grey-800 ${borderRadius} ${bgColor} ${className}`}>
    {children}
  </div>
);
export default Card;
